import { useEffect, useState, React } from "react";
import Spinner from "./Spinner";


export default function SubmittingDialog() {

    const styles = {
        overlay: {
            position: "fixed",
            height: "100%",
            width: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 999
        },

        box: {
            position: "absolute",
            top: "40%",
            left: "50%",
            marginLeft: -250,
            width: 500,
            textAlign: "center",
            borderRadius: 5,
            border: "1px solid #ccc",
            background: "#fff"
        }
    }


    return (
        <div style={styles.overlay} >
            <div style={styles.box } >
                <Spinner />
                <p>Submitting...</p>
            </div>
        </div>
    )

    
}


